import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "unordered-items-table" }
const _hoisted_2 = { class: "unordered-items-table__title unordered-table-title" }
const _hoisted_3 = { class: "unordered-table-title__label" }
const _hoisted_4 = {
  key: 0,
  class: "unordered-table-title__not-export-order not-export-order"
}
const _hoisted_5 = { class: "unordered-items-table__header unordered-table-header" }
const _hoisted_6 = {
  key: 0,
  class: "unordered-table-header__bulk-action-button-container bulk-action-button-container"
}
const _hoisted_7 = { class: "bulk-action-button-container__filter-order-status" }
const _hoisted_8 = { class: "unordered-items-table__contains" }
const _hoisted_9 = {
  key: 0,
  class: "unordered-items-table__head-area"
}
const _hoisted_10 = { class: "unordered-items-table__head-area--left" }

import OrderPageTab from '@/corePagesModule/components/OrderPageTab.vue';
import { storeToRefs } from 'pinia';
import { computed, onMounted, ref, watch } from 'vue';
import { i18n } from '@/i18n';
import TextButton from '@/components/input/Btn/TextButton.vue';
import { useOrderTableStore } from './useOrderTableStore';
import NewBaseTableContent from '@/corePagesModule/BaseTableContent/NewBaseTableContent.vue';
import { showInfoModal } from '@/corePagesModule/components/InfoModal/InfoModalManager';
import { openLoadingModal, openOkInformationModal } from '@/corePagesModule/components/modal/modalActions';
import OrderStatusReviseModal from '@/corePagesModule/components/OrderStatusReviseModal.vue';
import AttentionOrderDeleteModal from '../components/AttentionOrderDeleteModal.vue';
import { OrderStatus } from '@/coreDomainsModule/entities/arrival';
import SvgLoader from '@/utils/SvgLoader.vue';
import Pagination from '@/corePagesModule/components/Pagination.vue';
import { TableContentProperty } from '@/corePagesModule/BaseTableContent/interface/tableContentHeaders';
import { filterableOrderStatus } from '@/corePagesModule/BaseTableContent/components/order/orderStatus';
import OrderStatusVisibleButton from '../components/OrderStatusVisibleButton.vue';
import FilterModalButton from '@/corePagesModule/filterModal/FilterModalButton.vue';
import NormalOrderDeleteModal from '../components/NormalOrderDeleteModal.vue';
import RegisterOrderModal from '../components/registerOrderModal/RegisterOrderModal.vue';
import RegisterOrderBusinessExcelMenuDropdown from '../components/RegisterOrderBusinessExcelMenuDropdown.vue';
import InfoModal from '@/corePagesModule/components/InfoModal.vue';
import ExportOrderModal from '../components/exportModal/ExportOrderModal.vue';
import ReminderMailModal from '../components/ReminderMailModal.vue';
import { SaveReminderMailSettingsUseCase, ReminderMailData } from '../useCases/saveReminderMailSettingsUseCase';
import { isLoading } from '@/coreDomainsModule/uiLoadingState';
import { diContainer } from '../../coreContainer/container';
import { deleteReminder } from '@/businessRepository/reminderTable/driver';
import { waitLoading } from '@/corePagesModule/components/InfoModal/waitLoading';
import OrderGroupMenuDropdown from '../components/orderGroup/OrderGroupMenuDropdown.vue';
import OrderGroupEditModal from '../components/orderGroup/OrderGroupEditModal.vue';
import OrderGroupAddOrderModal from '../components/orderGroup/OrderGroupAddOrderModal.vue';
import { BULK_EDIT_ORDER_MENU_ITEMS, OrderGroupModalState } from '../constants';
import OrderGroupSelectModal from '../components/orderGroup/OrderGroupSelectModal.vue';
import { OrderGroupFactory } from '@/coreDomainsModule/factories/OrderGroupFactory';
import OrderGroupSelectInput from '../components/orderGroup/OrderGroupSelectInput.vue';
import OrderBasisInfoModal from '../components/OrderBasisInfoModal.vue';
import { simpleCopy } from '@/utils/deepCopy';
import { initPagingOptions } from '@/coreDomainsModule/paging';
import DropdownButton from '@/corePagesModule/components/DropdownButton.vue';
import ChangeEtaModal from '../components/ChangeEtaModal.vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'main',
  setup(__props) {

// 坂井TODO：名前がよくないので、unorderedItemsTableに変更する（カレンダーも似たような名前に）
const unorderedArrivalStore = useOrderTableStore();
const { state } = storeToRefs(unorderedArrivalStore);
// store内で定義されているstateを引っ張ってくる
const t = i18n.t;

const {
  onChangePaging,
  sortTableContentItems,
  fetchItems,
  $reset,
  updateEditOrder,
  updateOrderStatus,
  reloadTable,
  toggleStatusFilterIcon,
  onAppliedFilterModal,
  isNeedAttentionForDelete,
  deleteOrders,
  bulkRegisterOrderExcel,
  exportOrder,
  modifyOrder,
  modifyPartialDelivery,
  deletePartialDelivery,
  addPartialDelivery,
  updateMemo,
  deleteMemo,
  onNextDeleteOrderGroup,
  onNextOrderToOrderGroupUnlinking,
  getFilterItemsValue,
  bulkUpdateOrderEta,
} = unorderedArrivalStore;

const isRefreshTable = ref(false);
const reminderMailModalState = ref(false);
const orderBasisModalState = ref(false);
const selectedOrderId = ref('');
const reminderInitialMessage = ref('');
const reminderInitialDate = ref<string | null>(null);
const reminderInitialRecipients = ref<string[]>([]);
const bulkEtaChangeModalState = ref(false);

onMounted(async () => {
  await init();
});

/**
 * 初期化処理
 */
const init = async () => {
  $reset();
  fetchItems();
  state.value.renderingKey += 1;
};

/**
 * 編集モード中かどうか
 * @returns 編集モード中かどうか
 */
const isEditing = computed(() => {
  return state.value.editingOrderId !== '';
});

// 選択されたtableContentItems
const selectedTableContentItems = computed(() => {
  return state.value.tableContentItems.filter((item) => state.value.checkedIds.includes(item.displayId));
});

// TODO: 坂井 時短でstoreに書いていないだけで、最後にstoreに書く

/**
 * テーブル変更確認モーダルで保存ボタン押下時の処理
 */
const saveOrderTableChange = async () => {
  await _saveChangeEditableCellHistoryModal();
  return;
};

/**
 * テーブル変更確認モーダルで保存せず終了を押下時の処理
 */
const revertOrderTableChange = () => {
  // 再フェッチします
  const beforePagingOption = simpleCopy(state.value.pagingOptions ?? initPagingOptions(30));
  $reset();
  state.value.pagingOptions = beforePagingOption;
  fetchItems();
  state.value.forcePagingNumber = 1 + beforePagingOption.offset / beforePagingOption.pageSize;
  state.value.editingOrderId = '';
  closeChangeConfirmModal();
};

/**
 * テーブル変更確認モーダルを閉じる処理
 */
const closeChangeConfirmModal = () => {
  state.value.changeConfirmModalState = false;
};

/**
 * 編集モード終了モーダルを表示する
 */
const _saveChangeEditableCellHistoryModal = async () => {
  closeChangeConfirmModal();
  await updateEditOrder();
};

/**
 * 発注ステータスを一括更新処理
 * @param orderStatus - 発注ステータス
 */
const bulkReviseOrderStatus = async (orderStatus: OrderStatus) => {
  state.value.orderReviseModalState = false;
  const updateResult = await openLoadingModal<'success' | 'error'>(
    t('保存中・・・'),
    async () => {
      try {
        await updateOrderStatus(orderStatus);
        return 'success';
      } catch (error) {
        console.error('error', error);
        return 'error';
      }
    },
    []
  );

  if (updateResult === 'success') {
    await showInfoModal({
      modalTitle: t('保存完了'),
      modalDescription: t('正常に保存されました'),
      nextButtonLabel: t('OK'),
      icon: 'info',
      enableOutsideClick: false,
    });
  } else {
    await showInfoModal({
      modalTitle: t('エラー'),
      modalDescription: t(
        '何らかの理由で保存に失敗しました。再度時間を置いて実行していただくか、それでも解決しない場合はお問い合わせください。'
      ),
      nextButtonLabel: t('OK'),
      icon: 'error',
      enableOutsideClick: false,
    });
  }

  init();
  state.value.editingOrderId = '';
  isRefreshTable.value = true;
  isRefreshTable.value = false;
};

/**
 * 発注削除モーダルを表示する
 */
const openOrderDeleteModal = () => {
  state.value.orderDeleteModalState = true;
};

/**
 * 発注取り込みモーダルを表示する
 */
const openRegisterOrderModal = () => {
  state.value.registerOrderModalState = true;
};

/**
 * 発注出力モーダルを表示する
 */
const openExportOrderModal = () => {
  state.value.exportOrderModalState = true;
};

/**
 * 発注を一括削除
 * @param cancelReason - キャンセル理由
 */
const bulkDeleteOrder = async (cancelReason?: string) => {
  // まず、モーダルを閉じる
  state.value.orderDeleteModalState = false;

  const deleteResult = await openLoadingModal<'success' | 'error'>(
    t('削除中・・・'),
    async () => {
      try {
        await deleteOrders(state.value.checkedIds);
        return 'success';
      } catch (error) {
        console.error('error', error);
        return 'error';
      }
    },
    []
  );

  if (deleteResult === 'error') {
    await showInfoModal({
      modalTitle: t('エラー'),
      modalDescription: t('削除処理に失敗しました。時間を置いて再度実行してください。'),
      nextButtonLabel: t('OK'),
      icon: 'error',
      enableOutsideClick: false,
    });
  }

  init();
  fetchItems();
  state.value.editingOrderId = '';
  isRefreshTable.value = true;
  isRefreshTable.value = false;
};

/**
 * 発注エクセル登録モーダルを閉じた時の処理
 * @param file - 登録ファイル
 */
const onClosedRegisterOrderExcelModal = async (file?: File) => {
  if (!file) {
    openOkInformationModal('error', t('エラー'), 'OK', t('ファイルの読み取りに失敗しました'));
    return;
  }
  // 発注エクセル登録モーダルを閉じる
  state.value.registerOrderModalState = false;

  await bulkRegisterOrderExcel(file);

  // 初期化処理
  init();
};

/**
 * 発注出力モーダルで出力ボタンを押した際の処理
 * @param file - 選択されたファイル
 */
// const onExportOrderModalExportButtonClicked = async () => {
//   const isSuccess = await exportOrder();
const onExportOrderModalExportButtonClicked = async (file?: File) => {
  const isSuccess = await exportOrder(file);
  if (isSuccess) {
    init();
  }
  state.value.checkedIds = [];
};

/**
 * テーブルの変更ボタンを押した際の処理
 * @param id - ID
 */
const onClickEditButton = (id: string) => {
  state.value.editingOrderId = id;
  state.value.orderGroupState.originalOrderAmounts = state.value.items.reduce<Record<string, number>>((acc, item) => {
    acc[item.orderId] = item.orderAmount;
    return acc;
  }, {});
};

const isOrderGroupSelectModalOpening = computed(
  () =>
    state.value.orderGroupState.openingModal === OrderGroupModalState.OrderGroupEdit ||
    state.value.orderGroupState.openingModal === OrderGroupModalState.OrderGroupDelete
);

const getOrderGroupModalContent = computed(
  (): {
    title: string;
    description: string;
    nextButtonLabel: string;
    onNext: () => void;
  } =>
    state.value.orderGroupState.openingModal === OrderGroupModalState.OrderGroupDelete
      ? {
          title: t('削除する発注グループを選択'),
          description: t('選択した発注グループを削除します。'),
          nextButtonLabel: t('削除'),
          onNext: onNextDeleteOrderGroup,
        }
      : {
          title: t('編集する発注グループを選択'),
          description: t('選択した発注グループの取引を編集できます。'),
          nextButtonLabel: t('決定'),
          // eslint-disable-next-line jsdoc/require-jsdoc
          onNext: () => {
            state.value.orderGroupState.openingModal = OrderGroupModalState.None;
            state.value.orderGroupState.isOrderGroupEditMode = true;
          },
        }
);

watch(
  () => state.value.orderGroupState.isOrderGroupEditMode,
  async (val) => {
    if (val) {
      const targetGroupName = state.value.orderGroupState.targetGroupName;
      $reset();
      state.value.orderGroupState.isOrderGroupEditMode = true;
      state.value.orderGroupState.targetGroupName = targetGroupName;
      await fetchItems();
    }
  }
);

/**
 * 発注グループ編集モードから元の画面に戻った時の処理
 */
const onBackOrderGroupEditMode = async () => {
  state.value.orderGroupState.isOrderGroupEditMode = false;
  state.value.orderGroupState.targetGroupName = '';
  state.value.orderGroupState.editingGroup = OrderGroupFactory.create();
  await fetchItems();
};

/**
 * リマインダーメール設定モーダルを表示する
 * @param orderId - 発注ID
 */
const openReminderMailModal = (orderId: string) => {
  selectedOrderId.value = orderId;
  // 既存のリマインダーデータをセット（存在する場合）
  const orderItem = state.value.tableContentItems.find((item) => item.orderId === orderId);
  const reminderId = orderItem?.reminderMailDataId ?? null;
  const existing = reminderId ? state.value.reminderData.find((r) => r.dataId === reminderId) : null;
  // メモ欄にはメール本文ではなく「発注メモ」を初期表示する
  reminderInitialMessage.value = orderItem?.orderNote ?? '';
  reminderInitialDate.value = existing?.date ?? null;
  reminderInitialRecipients.value = existing?.mailTo ?? [];
  reminderMailModalState.value = true;
};

/**
 * リマインダーメール設定モーダルを閉じる
 */
const closeReminderMailModal = () => {
  reminderMailModalState.value = false;
  selectedOrderId.value = '';
  reminderInitialMessage.value = '';
  reminderInitialDate.value = null;
  reminderInitialRecipients.value = [];
};

/**
 * リマインダーメール設定を保存する
 * @param reminderMailData - リマインダーメールデータ
 */
const saveReminderMailSettings = async (reminderMailData: ReminderMailData) => {
  try {
    // 一連の処理が終わるまでテーブルはローディング表示にする
    state.value.loadingState = { status: { type: 'loading' } };
    // リマインダーメール設定を保存
    const saveReminderMailSettingsUseCase = new SaveReminderMailSettingsUseCase();
    const reminderResult = await saveReminderMailSettingsUseCase.execute(reminderMailData);

    if (reminderResult.success && reminderResult.dataId) {
      // 成功時：発注データのreminderMailDataIdを更新
      const orderId = reminderMailData.orderId;
      const orderItem = state.value.tableContentItems.find((item) => item.orderId === orderId);

      if (orderItem) {
        const updateResult = await diContainer.updateOrderReminderMailIdUseCase.Execute(
          orderId,
          reminderResult.dataId,
          orderItem.updatedAt,
          reminderMailData.message
        );

        if (updateResult.status.type === 'success') {
          // バックエンド更新でupdatedAtが更新されるため、最新を再取得
          await reloadTable();

          await showInfoModal({
            modalTitle: t('保存完了'),
            modalDescription: t('リマインドメールの設定に成功しました。'),
            nextButtonLabel: t('OK'),
            icon: 'info',
            enableOutsideClick: false,
          });
        } else {
          console.error('Failed to update order reminderMailDataId:', updateResult.status.error);
          await showInfoModal({
            modalTitle: t('エラー'),
            modalDescription: t('発注データの更新に失敗しました'),
            nextButtonLabel: t('OK'),
            icon: 'error',
            enableOutsideClick: false,
          });
        }
      }
    } else {
      console.error('Failed to save reminder mail settings:', reminderResult);
      await showInfoModal({
        modalTitle: t('エラー'),
        modalDescription: t('リマインドメールの設定に失敗しました。'),
        nextButtonLabel: t('OK'),
        icon: 'error',
        enableOutsideClick: false,
      });
    }
  } catch (error) {
    console.error('Error in saveReminderMailSettings:', error);
    await showInfoModal({
      modalTitle: t('エラー'),
      modalDescription: t('予期しないエラーが発生しました'),
      nextButtonLabel: t('OK'),
      icon: 'error',
      enableOutsideClick: false,
    });
  } finally {
    // ローディング解除（fetchが走っていればそちらで成功に遷移）
    if (state.value.loadingState.status.type === 'loading') {
      state.value.loadingState = { status: { type: 'success' } };
    }
    closeReminderMailModal();
  }
};

/**
 * リマインダーメール設定を削除し、発注から紐付きを解除する
 */
const deleteReminderMailSettings = async () => {
  try {
    const orderId = selectedOrderId.value;
    if (!orderId) return;

    const orderItem = state.value.tableContentItems.find((item) => item.orderId === orderId);
    const reminderId = orderItem?.reminderMailDataId ?? null;

    if (!orderItem || !reminderId) {
      // 何もすることがなければ終了
      return;
    }

    await waitLoading(
      (async () => {
        const delRes = await deleteReminder(reminderId);
        if (!delRes.success) throw new Error('Failed to delete reminder');

        // API仕様: dataId削除時は空文字を送る
        const updateRes = await diContainer.updateOrderReminderMailIdUseCase.Execute(orderId, '', orderItem.updatedAt);
        if (updateRes.status.type !== 'success') throw new Error('Failed to clear reminderMailDataId');

        await reloadTable();
      })(),
      t('削除中です・・・'),
      ''
    );
  } catch (error) {
    console.error('Error in deleteReminderMailSettings:', error);
    await showInfoModal({
      modalTitle: t('エラー'),
      modalDescription: t('リマインド削除に失敗しました'),
      nextButtonLabel: t('OK'),
      icon: 'error',
      enableOutsideClick: false,
    });
  } finally {
    closeReminderMailModal();
  }
};

/**
 * 発注根拠モーダルを開く
 * @param orderId - 発注ID
 */
const openOrderBasisInfoModal = async (orderId: string) => {
  selectedOrderId.value = orderId;
  const orderItem = state.value.tableContentItems.find((item) => item.orderId === orderId);
  const orderBasisId = orderItem?.orderBasisId ?? undefined;
  if (!orderBasisId) {
    // 紐づいた発注根拠がないのでエラーを出す
    await showInfoModal({
      modalTitle: t('エラーが発生しました。'),
      modalDescription: t('発注根拠が存在しません。'),
      isDisabledNextButton: true,
      backButtonLabel: t('OK'),
      colorStyle: 'error',
      icon: 'error',
    });
    return;
  }

  orderBasisModalState.value = true;
};

/**
 * 発注根拠モーダルを閉じる
 */
const closeOrderBasisInfoModal = () => {
  selectedOrderId.value = '';
  orderBasisModalState.value = false;
};

/**
 * 一括編集メニューボタンを押した時の処理
 * @param value - 選択した値
 */
const onClickBulkEditButton = (value: string) => {
  if (value === 'eta') {
    if (!checkEditableOrder()) {
      showInfoModal({
        modalTitle: t('納期を変更できない発注が含まれています'),
        modalDescription: t(
          '数量回答待ち/分納/確定/納入済みのステータスの発注は一括で納期を変更することができません。先にステータスを変更してください。'
        ),
        backButtonLabel: t('OK'),
        isDisabledNextButton: true,
      });
    } else bulkEtaChangeModalState.value = true;
  } else if (value === 'status') {
    state.value.orderReviseModalState = true;
  }
};

/**
 * ETAを一括編集する発注が条件に合致しているかチェックする
 */
const checkEditableOrder = (): boolean => {
  const invalidOrderStatus = [
    OrderStatus.Confirmed,
    OrderStatus.Delivered,
    OrderStatus.DeliveryDateConfirmed,
    OrderStatus.DisplayEnded,
    OrderStatus.PartialDelivery,
  ] as OrderStatus[];
  return !state.value.items
    .filter((order) => state.value.checkedIds.includes(order.orderId))
    .some((order) => invalidOrderStatus.includes(order.orderStatus));
};

/**
 * ETA一括編集モーダルのonNext
 * @param eta - 変更するETA
 */
const onNextBulkEtaEditModal = async (eta: number | null) => {
  if (!eta) return;
  bulkEtaChangeModalState.value = false;
  bulkUpdateOrderEta(eta);
};

return (_ctx: any,_cache: any) => {
  const _component_RouterLink = _resolveComponent("RouterLink")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("span", _hoisted_3, _toDisplayString(_unref(t)('発注')), 1),
        (!isEditing.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
              _createVNode(_component_RouterLink, {
                class: "not-export-order__label",
                to: "/not-exported-order"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_unref(t)('未出力の発注ページに切り替え')), 1)
                ], undefined, true),
                _: 1
              }),
              _createVNode(SvgLoader, {
                class: "not-export-order__icon",
                name: "orderSwitchIcon"
              })
            ]))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createVNode(OrderPageTab, { class: "" }),
        (!isEditing.value && !_unref(state).orderGroupState.isOrderGroupEditMode)
          ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
              _createVNode(DropdownButton, {
                options: _unref(BULK_EDIT_ORDER_MENU_ITEMS),
                disabled: !_unref(state).checkedIds.length,
                onClickOption: onClickBulkEditButton
              }, {
                label: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_unref(t)('発注一括編集')), 1)
                ]),
                _: 1
              }, 8, ["options", "disabled"]),
              _createVNode(TextButton, {
                "button-style": 'btn-secondary',
                size: 'btn-md',
                "on-click": openOrderDeleteModal,
                disabled: _unref(state).checkedIds.length === 0,
                class: "bulk-action-button-container__button"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_unref(t)('発注削除')), 1)
                ], undefined, true),
                _: 1
              }, 8, ["disabled"]),
              _createVNode(TextButton, {
                class: "bulk-action-button-container__button",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (openRegisterOrderModal()))
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_unref(t)('発注情報の取込')), 1)
                ], undefined, true),
                _: 1
              }),
              _createVNode(TextButton, {
                "button-style": 'btn-primary',
                size: 'btn-md',
                "on-click": openExportOrderModal,
                disabled: _unref(state).checkedIds.length === 0,
                class: "bulk-action-button-container__button bulk-action-button-container__export-button"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_unref(t)('発注出力')) + " ", 1),
                  _createVNode(SvgLoader, { name: "download" })
                ], undefined, true),
                _: 1
              }, 8, ["disabled"]),
              _createElementVNode("div", _hoisted_7, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(filterableOrderStatus), (status, index) => {
                  return (_openBlock(), _createBlock(OrderStatusVisibleButton, {
                    key: index,
                    class: "order-status__container--badge",
                    "order-status-str": status,
                    "is-show-order-status": _unref(state).orderStatusFilterItem[status],
                    onClick: ($event: any) => (_unref(toggleStatusFilterIcon)(status, $event))
                  }, null, 8, ["order-status-str", "is-show-order-status", "onClick"]))
                }), 128))
              ])
            ]))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_8, [
        (!isEditing.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
              _createElementVNode("div", _hoisted_10, [
                _createVNode(FilterModalButton, {
                  class: "detail-filter-modal",
                  "filter-modal-type": 'order',
                  "select-input-index": 0,
                  "filter-items": _unref(getFilterItemsValue)().value,
                  onApply: _cache[1] || (_cache[1] = (filteredContents) => _unref(onAppliedFilterModal)(filteredContents))
                }, null, 8, ["filter-items"]),
                (_unref(state).orderGroupState.isOrderGroupEditMode)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                      _createVNode(OrderGroupSelectInput, {
                        label: "",
                        onChange: _cache[2] || (_cache[2] = async () => await _unref(fetchItems)())
                      }),
                      _createVNode(TextButton, {
                        "button-style": "btn-secondary",
                        onClick: _cache[3] || (_cache[3] = 
                () => {
                  _unref(state).orderGroupState.openingModal = _unref(OrderGroupModalState).OrderGroupInfoEdit;
                }
              )
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_unref(t)('発注グループ情報を編集')), 1)
                        ], undefined, true),
                        _: 1
                      }),
                      _createVNode(TextButton, {
                        "button-style": "btn-secondary",
                        disabled: !_unref(state).checkedIds.length,
                        onClick: _unref(onNextOrderToOrderGroupUnlinking)
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_unref(t)('発注グループから外す')), 1)
                        ], undefined, true),
                        _: 1
                      }, 8, ["disabled", "onClick"]),
                      _createVNode(TextButton, {
                        "button-style": "btn-secondary",
                        onClick: onBackOrderGroupEditMode
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_unref(t)('元のページに戻る')), 1)
                        ], undefined, true),
                        _: 1
                      })
                    ], 64))
                  : (_openBlock(), _createBlock(OrderGroupMenuDropdown, { key: 1 }))
              ]),
              (_unref(state).pagingOptions)
                ? (_openBlock(), _createBlock(Pagination, {
                    key: 0,
                    "paging-options": _unref(state).pagingOptions,
                    "is-loading": _unref(state).loadingState.status.type === 'loading',
                    "is-order-page": "",
                    "set-page-number": _unref(state).forcePagingNumber,
                    class: "pagination",
                    onOnChangePage: _cache[4] || (_cache[4] = ($event: any) => (_unref(onChangePaging)($event)))
                  }, null, 8, ["paging-options", "is-loading", "set-page-number"]))
                : _createCommentVNode("", true)
            ]))
          : _createCommentVNode("", true),
        (_openBlock(), _createBlock(NewBaseTableContent, {
          key: _unref(state).renderingKey,
          "prop-table-content-properties": _unref(state).tableContentProperties,
          "prop-display-objects": _unref(state).tableContentItems,
          "prop-loading-status": _unref(state).loadingState,
          "prop-table-type": 'firmOrderTable',
          "prop-is-reset": isRefreshTable.value,
          "prop-editing-id": _unref(state).editingOrderId,
          "prop-is-editing": _unref(state).orderGroupState.isOrderGroupEditMode,
          class: "unordered-items-table__contains unordered-items-table__contains--table",
          onChecked: _cache[5] || (_cache[5] = ($event: any) => (_unref(state).checkedIds = $event)),
          onOnClickSort: _cache[6] || (_cache[6] = (sortKey, isAsc) => _unref(sortTableContentItems)(sortKey, isAsc)),
          onReload: _unref(reloadTable),
          onOnClickEdit: _cache[7] || (_cache[7] = ($event: any) => (onClickEditButton($event))),
          onOnClickSave: _cache[8] || (_cache[8] = ($event: any) => (_unref(state).changeConfirmModalState = true)),
          onOnChangeOrderProperty: _cache[9] || (_cache[9] = (orderId, key, value) => _unref(modifyOrder)(orderId, key, value)),
          onOnChangePartialDelivery: _cache[10] || (_cache[10] = 
          (orderId, partialDeliveryId, key, value) => _unref(modifyPartialDelivery)(orderId, partialDeliveryId, key, value)
        ),
          onOnClickDelete: _cache[11] || (_cache[11] = (orderId, partialDeliveryId) => _unref(deletePartialDelivery)(orderId, partialDeliveryId)),
          onOnClickAddPartialDelivery: _cache[12] || (_cache[12] = (orderId) => _unref(addPartialDelivery)(orderId)),
          onOnClickSaveMemo: _cache[13] || (_cache[13] = (orderId, memo) => _unref(updateMemo)(orderId, memo)),
          onOnClickDeleteMemo: _cache[14] || (_cache[14] = (orderId) => _unref(deleteMemo)(orderId)),
          onOnClickReminderMail: openReminderMailModal,
          onOnClickOrderBasis: openOrderBasisInfoModal
        }, null, 8, ["prop-table-content-properties", "prop-display-objects", "prop-loading-status", "prop-is-reset", "prop-editing-id", "prop-is-editing", "onReload"]))
      ]),
      _createVNode(OrderStatusReviseModal, {
        "modal-state": _unref(state).orderReviseModalState,
        items: selectedTableContentItems.value,
        "is-bulk-edit": true,
        onCanceled: _cache[15] || (_cache[15] = () => (_unref(state).orderReviseModalState = false)),
        onConfirm: _cache[16] || (_cache[16] = ($event: any) => (bulkReviseOrderStatus($event as OrderStatus)))
      }, null, 8, ["modal-state", "items"]),
      (_unref(state).orderDeleteModalState)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            (_unref(isNeedAttentionForDelete)())
              ? (_openBlock(), _createBlock(AttentionOrderDeleteModal, {
                  key: 0,
                  "modal-state": _unref(state).orderDeleteModalState,
                  onCanceled: _cache[17] || (_cache[17] = () => (_unref(state).orderDeleteModalState = false)),
                  onConfirm: _cache[18] || (_cache[18] = ($event: any) => (bulkDeleteOrder($event as OrderStatus)))
                }, null, 8, ["modal-state"]))
              : (_openBlock(), _createBlock(NormalOrderDeleteModal, {
                  key: 1,
                  "modal-state": _unref(state).orderDeleteModalState,
                  onCanceled: _cache[19] || (_cache[19] = () => (_unref(state).orderDeleteModalState = false)),
                  onConfirm: _cache[20] || (_cache[20] = ($event: any) => (bulkDeleteOrder()))
                }, null, 8, ["modal-state"]))
          ], 64))
        : _createCommentVNode("", true)
    ]),
    _createVNode(RegisterOrderModal, {
      "modal-state": _unref(state).registerOrderModalState,
      onCloseModal: _cache[21] || (_cache[21] = () => (_unref(state).registerOrderModalState = false)),
      onExportOrder: _cache[22] || (_cache[22] = ($event: any) => (onClosedRegisterOrderExcelModal($event)))
    }, null, 8, ["modal-state"]),
    _createVNode(InfoModal, {
      "modal-state": _unref(state).changeConfirmModalState,
      icon: "info",
      "enable-outside-click": false,
      "back-button-label": _unref(t)('キャンセル'),
      "next-button-label": _unref(t)('保存する'),
      onOnNext: saveOrderTableChange,
      onOnBack: closeChangeConfirmModal
    }, {
      title: _withCtx(() => [
        _createTextVNode(_toDisplayString(_unref(t)('編集モードの終了')), 1)
      ]),
      description: _withCtx(() => [
        _createTextVNode(_toDisplayString(_unref(t)('ここまでの編集及び変更点を保存しますか')), 1)
      ]),
      footer: _withCtx(() => [
        _createElementVNode("div", {
          class: "confirm-edit-modal__footer",
          onClick: revertOrderTableChange
        }, _toDisplayString(_unref(t)('保存せずに終了(発注画面)')), 1)
      ]),
      _: 1
    }, 8, ["modal-state", "back-button-label", "next-button-label"]),
    _createVNode(ExportOrderModal, {
      "modal-state": _unref(state).exportOrderModalState,
      onCloseModal: _cache[23] || (_cache[23] = ($event: any) => (_unref(state).exportOrderModalState = false)),
      onExportOrder: _cache[24] || (_cache[24] = ($event: any) => (onExportOrderModalExportButtonClicked($event)))
    }, null, 8, ["modal-state"]),
    _createVNode(InfoModal, {
      "modal-state": _unref(isLoading)(_unref(state).updateMemoState.loading.status),
      icon: "loading",
      "enable-outside-click": false
    }, {
      title: _withCtx(() => [
        _createTextVNode(_toDisplayString(_unref(state).updateMemoState.workType === 'delete' ? _unref(t)('メモを削除しています') : _unref(t)('メモを保存しています')), 1)
      ]),
      _: 1
    }, 8, ["modal-state"]),
    _createVNode(ReminderMailModal, {
      "modal-state": reminderMailModalState.value,
      "order-id": selectedOrderId.value,
      "initial-message": reminderInitialMessage.value,
      "initial-reminder-date": reminderInitialDate.value,
      "initial-recipients": reminderInitialRecipients.value,
      onCloseModal: closeReminderMailModal,
      onSaveReminderMail: saveReminderMailSettings,
      onDeleteReminderMail: deleteReminderMailSettings
    }, null, 8, ["modal-state", "order-id", "initial-message", "initial-reminder-date", "initial-recipients"]),
    _createVNode(OrderGroupEditModal),
    _createVNode(OrderGroupAddOrderModal),
    _createVNode(OrderGroupSelectModal, {
      "is-opening": isOrderGroupSelectModalOpening.value,
      title: getOrderGroupModalContent.value.title,
      description: getOrderGroupModalContent.value.description,
      "next-button-label": getOrderGroupModalContent.value.nextButtonLabel,
      onNext: getOrderGroupModalContent.value.onNext,
      onBack: _cache[25] || (_cache[25] = 
      () => {
        _unref(state).orderGroupState.openingModal = _unref(OrderGroupModalState).None;
        _unref(state).orderGroupState.targetGroupName = '';
      }
    )
    }, null, 8, ["is-opening", "title", "description", "next-button-label", "onNext"]),
    _createVNode(OrderBasisInfoModal, {
      "modal-state": orderBasisModalState.value,
      "order-data": _unref(state).tableContentItems.find((item) => item.orderId === selectedOrderId.value),
      onClose: closeOrderBasisInfoModal
    }, null, 8, ["modal-state", "order-data"]),
    _createVNode(ChangeEtaModal, {
      "modal-state": bulkEtaChangeModalState.value,
      "selected-count": _unref(state).checkedIds.length,
      onClose: _cache[26] || (_cache[26] = ($event: any) => (bulkEtaChangeModalState.value = false)),
      onNext: onNextBulkEtaEditModal
    }, null, 8, ["modal-state", "selected-count"])
  ], 64))
}
}

})